// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default (func: any, ...args: any[]) => (...moreArgs: any[]) => func(...args, ...moreArgs);
